<template>
  <section class="flex min-h-screen flex-col bg-gray-50">
    <AppHeader class="sticky top-0" />
    <main
      role="main"
      class="mx-auto w-full max-w-screen-2xl flex-1"
      :class="{ 'bg-white': !$route.path.split('/').includes('teacher') }"
    >
      <NuxtLoadingIndicator color="#0885F2" />
      <WtToast />
      <NuxtPage />
    </main>
  </section>
</template>

<script setup>
definePageMeta({
  middleware: 'auth'
})
</script>
